import { NgModule } from '@angular/core';
import { WorkoutDetailPage } from 'pages/workout-detail/workout-detail';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [WorkoutDetailPage],
    imports: [PagesModule, ComponentsModule],
    exports: [WorkoutDetailPage]
})
export class WorkoutDetailPageModule {}
